import(/* webpackMode: "eager" */ "/opt/lumi/src/lumi/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lumi/src/lumi/src/components/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WordsReadChart"] */ "/opt/lumi/src/lumi/src/components/WordsReadChart.tsx");
